import { DataGrid, EntityDialog } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { Authorization, Config, ErrorHandling, notifyInfo } from "@serenity-is/corelib/q";
import { IdleTimeout } from "@serenity-is/pro.extensions";
import { siteLanguageList } from "./Helpers/LanguageList";
import { HubConnectionBuilder } from "wwwroot/Scripts/microsoft/signalr/src";
import { registerLicense } from '@syncfusion/ej2-base';
import { UserPreferenceStorage } from '@serenity-is/extensions';

Config.rootNamespaces.push('CRMBase');
Config.rootNamespaces.push('_Ext');
EntityDialog.defaultLanguageList = siteLanguageList;
gridDefaults.useCssVars = true;
DataGrid.defaultPersistanceStorage = new UserPreferenceStorage();

registerLicense('ORg4AjUWIQA/Gnt2V1hiQlBGfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5adkNjUXtXdHNST2Vd')
if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;

$(() => {
    // let demo page use its own settings for idle timeout
    if (window.location.pathname.indexOf('Samples/IdleTimeout') > 0)
        return;

    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {

        new IdleTimeout({
            activityTimeout: 598 * 60,
            warningDuration: 2 * 60
        });
    }
});

//add signalR BEGIN

// The HubConnectionBuilder class creates a new builder for 
// configuring the server connection. 
// The withUrl function configures the hub URL.
// Hub URL was defined in Startup.cs 
const connection = new HubConnectionBuilder()
    .withUrl("/notificationhub")
    .withAutomaticReconnect()
    .build();

// Listening to a message with the name 'notifyMessage'
// and display the message using Q.notifyInfo
connection.on("notifyMessage", (message) => {
    notifyInfo(message);
});

try {
    connection.start();
} catch (e) {
    console.error(e.toString());
}
    //add signalR END